<template>
  <div>
    <Modal v-model="modifyModal" :mask-closable="false" width="600">
      <p slot="header" class="text-center">{{ opType === 1 ? '新增' : '编辑' }}主题媒体产品</p>
      <Form ref="formValidate" :model="productModel" :rules="ruleValidate" :label-width="140">
        <FormItem label="所属资产" prop="assetIds">
          <Select v-model="productModel.assetIds" size="small" placeholder="选择资产">
            <Option v-for="item in assetArray" :key="'assetId_' + item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="所属产品" prop="productId">
          <Select v-model="productModel.productId" size="small" placeholder="选择产品">
            <Option v-for="item in productArray" :key="'product_' + item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称" prop="productskuName">
          <Input v-model="productModel.productskuName" size="small" placeholder="填写名称" />
        </FormItem>
        <FormItem label="资源">
          <Button type="primary" size="small" @click="handleChoiceRes">选择资源</Button>
          <div v-show="selectedRes.code&&selectedRes.code!==''">
            <Tag>{{ selectedRes.code }}</Tag>
          </div>
        </FormItem>
        <FormItem label="最小售卖天数" prop="minday">
          <InputNumber v-model="productModel.minday" :min="1" size="small" style="width:100%" placeholder="最小售卖天数">
          </InputNumber>
        </FormItem>
        <FormItem label="媒介使用费" prop="usePrice">
          <InputNumber :min="0" v-model="productModel.usePrice"
            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" size="small" style="width:100%" placeholder="输入媒介使用费">
          </InputNumber>
        </FormItem>
        <Row :gutter="8">
          <i-col span="12">
            <FormItem label="最低限价" prop="statementPrice">
              <InputNumber :min="0" :max="productModel.usePrice" v-model="productModel.statementPrice"
                :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\￥\s?|(,*)/g, '')" size="small" style="width:100%" placeholder="输入最低限价"
                @on-change="onChangeStatePrice">
              </InputNumber>
            </FormItem>
          </i-col>
          <i-col span="12">
            <FormItem label="最低限价折扣">
              <InputNumber size="small" :max="10" :min="0" :step="0.5" v-model="discount" @on-change="onChangeDiscount">
              </InputNumber>
              <span class="p-l-5">折</span>
            </FormItem>
          </i-col>
        </Row>
        <!-- <FormItem label="服务费刊例价">
          <InputNumber :min="0" v-model="productModel.produceCost"
            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" size="small" style="width:100%" placeholder="输入服务费刊例价">
          </InputNumber>
        </FormItem>
        <FormItem label="服务费结算价">
          <InputNumber :min="0" v-model="productModel.produceStatement"
            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\￥\s?|(,*)/g, '')" size="small" style="width:100%" placeholder="输入服务费结算价">
          </InputNumber>
        </FormItem> -->
        <FormItem label="施工缓冲期">
          <InputNumber size="small" style="width:90%" :min="0" v-model="productModel.bufferDay" /><span
            class="m-l-5">天</span>
        </FormItem>
        <FormItem label="是否可用">
          <i-switch size="large" v-model="productModel.enabled">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="productModel.desc" type="textarea" :rows="2" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modifyModal = false">取消</Button>
        <Button type="primary" @click="handleSave">确定</Button>
      </div>
    </Modal>
    <choice-res ref="choiceResRef" :projectId="projectId" @onSetRes="onSetRes"/>
  </div>
</template>

<script>
import { productMixins } from '../mixins/product'
import { commonMixins } from '@/assets/mixins/common'

import { addFix, editFix } from '@/api/product/productskuedit'

import ChoiceRes from './common/ChoiceRes.vue'

export default {
  mixins: [productMixins, commonMixins],
  props: {
    projectId: [Number],
    saveSuccessFun: Function
  },
  components: { ChoiceRes },
  data () {
    return {
      modifyModal: false,
      productModel: {
        assetIds: null,
        categoryId: 4, // 主题媒体，类目id固定为4
        desc: '',
        enabled: true,
        minday: 1,
        productId: null,
        productskuName: '',
        usePrice: 1,
        statementPrice: -1, // 代理商结算价
        produceCost: 0, // 服务费
        produceStatement: 0, // 服务费结算价
        // resourceInfos: '',
        cityCode: '',
        cityName: '',
        bufferDay: 0, // 施工缓冲期，单位：天
        projectId: undefined,
        resourceId: undefined
      },
      selectedRes: {}, // 选中的资源
      discount: 0, // 最低限价折扣
      productskuId: null, // 当前主题产品id，编辑更新时用
      existResInfos: [], // 当前主题媒体已有资源信息
      ruleValidate: {
        assetIds: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        categoryId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        minday: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ],
        productId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        productskuName: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        usePrice: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ],
        statementPrice: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' },
          { pattern: /(^\d+(\.{0,1}\d+){0,1}$)/, message: ' ' }
        ]
      },
      resModal: false,
      resBoxShow: 'tab_choice',
      resQuery: {
        pageSize: 15,
        pageNumber: 1,
        assetId: null,
        stationId: null,
        enabled: null,
        position: null,
        resourcetypeId: null,
        keyword: ''
      },
      stationArray: [],
      positionArray: [],
      resourceTypeArray: [],
      statusArray: [
        { value: 1, name: '可用' },
        { value: 0, name: '不可用' }
      ],
      resList: [],
      resTotal: 0,
      resColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '编号', align: 'center', key: 'code' },
        { title: '所属站点', align: 'center', key: 'stationName' },
        { title: '资源类型', align: 'center', key: 'resourcetypeName' },
        {
          title: '状态',
          align: 'center',
          key: 'enabled',
          render: (h, params) => {
            return h('span', params.row.enabled ? '可用' : '不可用')
          }
        }
      ]
      // selectedResArray: []
    }
  },
  computed: {
    assetArray () {
      return this.$store.state.productManage.assetArray
    },
    storageProducts () {
      return this.$store.state.productManage.productArray
    },
    opType () {
      return this.$store.state.productManage.opType
    }
  },
  mounted () {
    this.getCompanyInfo()
  },
  methods: {
    initShow (data) {
      if (this.opType === 1) {
        // 新增
        // this.resBoxShow = 'tab_choice'
        // this.selectedResArray = []
        Object.assign(this.$data.productModel, this.$options.data().productModel)
        this.productModel.projectId = this.projectId
      } else {
        // 编辑
        if (data) {
          // // 先获取产品数据
          // this.getProductData({ categoryId: data.categoryId }).then(res => {
          //   // 防止赋值不成功
          //   this.productModel.productId = data.productId
          // })
          Object.keys(this.productModel).forEach(key => {
            this.productModel[key] = data[key]
          })
          this.productModel.assetIds = parseInt(data.assetIds)
          this.productModel.productskuName = data.name
          this.productskuId = data.id

          this.selectedRes = {
            code: data.resourceCode,
            id: data.resourceId
          }

          if (data.statementPrice <= 0) {
            this.discount = 0
            // this.productModel.statementPrice = 0
          } else {
            this.onChangeStatePrice()
          }

          // this.resBoxShow = 'tab_exist'
          // this.selectedResArray = data.fixResourceList.map(x => {
          //   return {
          //     id: x.resourceId,
          //     code: x.resourceCode,
          //     duration: x.duration,
          //     period: x.period,
          //     deviceId: x.deviceId
          //   }
          // })
        }
      }
      this.modifyModal = true
    },
    onChangeDiscount () {
      const price = this.productModel.usePrice * (this.discount / 10)
      this.productModel.statementPrice = Math.round(price * 10000) / 10000
    },
    onChangeStatePrice () {
      const discount = (this.productModel.statementPrice / this.productModel.usePrice) * 10
      this.discount = discount < 0 ? 0 : Math.round(discount * 100) / 100
    },
    handleChoiceRes () {
      this.$nextTick(() => {
        this.$refs.choiceResRef.showModal()
      })
    },
    onSetRes (obj) {
      if (obj) {
        this.selectedRes = obj
      }
    },
    handleSave () {
      if (!this.selectedRes || !this.selectedRes.id) {
        this.$Notice.error({ desc: '请选择一个资源' })
        return
      }
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.$Modal.confirm({
            title: '操作提示',
            content: '确定信息无误，并提交？',
            onOk: () => {
              // const resInfos = this.selectedResArray.map(x => {
              //   return {
              //     resourceId: x.id,
              //     duration: x.duration,
              //     period: x.period
              //   }
              // })
              // this.productModel.resourceInfos = JSON.stringify(resInfos)
              this.productModel.assetIds = JSON.stringify([this.productModel.assetIds])
              // 设置资源
              this.productModel.resourceId = this.selectedRes.id

              if (this.opType === 1) { // 新增
                this.productModel.cityCode = this.companyInfo.cityCode
                this.productModel.cityName = this.companyInfo.cityName
                addFix(this.productModel).then(res => {
                  this.modifyModal = false
                  if (res && res.errcode === 0) {
                    this.$Notice.success({ desc: '操作成功' })
                    // this.selectedResArray = []
                    this.saveSuccessFun()
                  }
                })
              } else {
                const postData = Object.assign(this.productModel, { productskuId: this.productskuId })
                editFix(postData).then(res => {
                  this.modifyModal = false
                  if (res && res.errcode === 0) {
                    this.$Notice.success({ desc: '操作成功' })
                    // this.selectedResArray = []
                    this.saveSuccessFun()
                  }
                })
              }
            }
          })
        }
      })
    }
  },
  watch: {
    storageProducts: {
      deep: true,
      immediate: true,
      handler (val) {
        this.productArray = val
      }
    }
  }
}
</script>
